import { default as _91id_931mngoIAW2vMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/appointment/[id].vue?macro=true";
import { default as appointmentq7qZSQHQ8kMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/appointment.vue?macro=true";
import { default as _91id_93a7jzfjYBVsMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/event/[id].vue?macro=true";
import { default as eventzL9l6UaTPRMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/event.vue?macro=true";
import { default as eventIFrame8Fs6Gzyjg0Meta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFrame.vue?macro=true";
import { default as eventIFramePreviewM7CzufqiLbMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFramePreview.vue?macro=true";
import { default as eventIFrameTestY6Paefyu1yMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFrameTest.vue?macro=true";
import { default as index1a5baIKrD3Meta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/index.vue?macro=true";
import { default as _91registration_93pbr4vWz1EPMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/overview/[registration].vue?macro=true";
import { default as overview1FfC91VWa4Meta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/overview.vue?macro=true";
import { default as participantscA0BemHkdcMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/participants.vue?macro=true";
import { default as participantsDetailsOHBAmeb9AZMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/participantsDetails.vue?macro=true";
import { default as paymentb9nAGAKNNLMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/payment.vue?macro=true";
import { default as registrationDetailsJplHKA2UmFMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/registrationDetails.vue?macro=true";
import { default as regStartCqERElty3HMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/regStart.vue?macro=true";
import { default as regSummaryENtwi1KWUAMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/regSummary.vue?macro=true";
import { default as _91id_93zeBBLJaN5sMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id].vue?macro=true";
import { default as registration506rfXqXxuMeta } from "/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration.vue?macro=true";
export default [
  {
    name: "appointment___de",
    path: "/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___de",
    path: "/termin/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "appointment___en",
    path: "/en/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___de",
    path: "/event",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___de",
    path: "/veranstaltung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___en",
    path: "/en/event",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "eventIFrame___de",
    path: "/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrame___en",
    path: "/en/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___de",
    path: "/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___en",
    path: "/en/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___de",
    path: "/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___en",
    path: "/en/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "overview___de",
    path: "/overview",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___de",
    path: "/uebersicht/:registration()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "overview___en",
    path: "/en/overview",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___en",
    path: ":registration()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "registration___de",
    path: "/registration",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___de",
    path: "/anmeldung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___de",
    path: "teilnehmer",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___de",
    path: "teilnehmerDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___de",
    path: "zahlung",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___de",
    path: "anmeldungsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___de",
    path: "start",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___de",
    path: "zusammenfassung",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "registration___en",
    path: "/en/registration",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___en",
    path: "/en/registration/participants",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___en",
    path: "/en/registration/participantsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___en",
    path: "/en/registration/payment",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___en",
    path: "/en/registration/registrationDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___en",
    path: "/en/registration/start",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___en",
    path: "/en/registration/summary",
    component: () => import("/home/forge/amosweb.de/releases/20250724120740/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  }
]